/* Sticky buy bar: visible while the main "add to cart" button is out of the viewport.
   The bar button mirrors the main button and submits the same product form (form.requestSubmit(mainButton)),
   so the cart and the add_to_cart analytics event work exactly as with the main button (one submit, one event). */
(function () {
  'use strict';

  function setup(bar) {
    var form = document.getElementById(bar.getAttribute('data-form-id'));
    var main = form && form.querySelector('[data-add-to-cart]');
    if (!main) return;
    var button = bar.querySelector('[data-sticky-atc-button]');
    var priceOut = bar.querySelector('[data-sticky-atc-price]');
    var variantOut = bar.querySelector('[data-sticky-atc-variant]');
    var section = form.closest('[data-product-section]') || document;
    var priceIn = section.querySelector('[data-product-price]');
    var root = document.documentElement;
    var mainOut = false;
    var shown = null;

    function syncButton() {
      var text = (main.querySelector('[data-add-to-cart-text]') || main).textContent.trim();
      if (button.textContent !== text) button.textContent = text;
      button.disabled = main.disabled;
    }

    function syncPrice() {
      if (!priceIn || !priceOut) return;
      var copy = priceIn.cloneNode(true);
      copy.querySelectorAll('[data-sale-badge]').forEach(function (el) { el.remove(); });
      if (priceOut.innerHTML !== copy.innerHTML) priceOut.innerHTML = copy.innerHTML;
    }

    function syncVariant() {
      if (!variantOut) return;
      var labels = Array.prototype.map.call(section.querySelectorAll('.product-option [data-option-value-label]'), function (el) {
        return el.textContent.trim();
      }).filter(Boolean);
      if (labels.length) variantOut.textContent = labels.join(' / ');
    }

    function bannerOpen() {
      var banner = document.getElementById('shopify-pc__banner');
      if (!banner || !banner.getClientRects().length) return false;
      var style = getComputedStyle(banner);
      return style.display !== 'none' && style.visibility !== 'hidden';
    }

    function setHeight() {
      root.style.setProperty('--aura-sticky-atc-h', bar.offsetHeight + 'px');
    }

    function update() {
      var show = mainOut && !root.classList.contains('is-lightbox-open') && !bannerOpen();
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }

    button.addEventListener('click', function () {
      if (main.disabled) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(main);
      else main.click();
    });

    // Header is sticky: a button hidden under it counts as out of view.
    var header = document.querySelector('.site-header');
    var top = header ? Math.round(header.getBoundingClientRect().height) : 0;
    new IntersectionObserver(function (entries) {
      mainOut = !entries[entries.length - 1].isIntersecting;
      update();
    }, { rootMargin: '-' + top + 'px 0px 0px 0px', threshold: 0 }).observe(main);

    new MutationObserver(syncButton).observe(main, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    if (priceIn) new MutationObserver(syncPrice).observe(priceIn, { childList: true, characterData: true, subtree: true, attributes: true });
    new MutationObserver(update).observe(root, { attributes: true, attributeFilter: ['class'] });

    // Shopify cookie banner sits at the bottom too: the bar waits until it is closed.
    var watchedBanner = null;
    function watchBanner() {
      var banner = document.getElementById('shopify-pc__banner');
      if (banner && banner !== watchedBanner) {
        watchedBanner = banner;
        new MutationObserver(update).observe(banner, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
      }
      update();
    }
    new MutationObserver(watchBanner).observe(document.body, { childList: true });
    document.addEventListener('visitorConsentCollected', function () { setTimeout(update, 0); });
    watchBanner();

    section.addEventListener('aura:variant-change', syncVariant);
    // The room at the end of the page is reserved from the start (not only while the bar is shown),
    // otherwise the bar appearing at the very bottom would cover the end of the footer.
    root.classList.add('has-sticky-atc');
    if (!document.querySelector('.site-footer')) root.classList.add('no-site-footer');
    setHeight();
    if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(bar);

    syncButton();
    syncPrice();
    syncVariant();
  }

  function init() {
    document.querySelectorAll('[data-sticky-atc]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
